import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

import type { EsnFilterChipKind, EsnSortDirection } from '../../../shared/types/forms';
import { IconComponent } from '../../atoms/icon/icon.component';

/**
 * A toolbar filter or sort trigger that sits beside the search field. A status chip toggles
 * on and off; a sort chip, once active, flips its direction on each press.
 */
@Component({
  selector: 'esn-filter-chip',
  imports: [IconComponent],
  templateUrl: './filter-chip.component.html',
  styleUrl: './filter-chip.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterChipComponent {
  readonly kind = input<EsnFilterChipKind>('status');
  readonly selected = model(false);
  readonly direction = model<EsnSortDirection>('desc');

  readonly clicked = output<MouseEvent>();

  protected handleClick(event: MouseEvent): void {
    if (this.kind() === 'sort' && this.selected()) {
      this.direction.update((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      this.selected.update((on) => !on);
    }
    this.clicked.emit(event);
  }
}
